import { InterRuche } from "./interRuche";
import { DateJson } from "../outils/dateJson";

export class Intervention {
    id_inter_rucher: string = '-1';
    id_rucher: string;
    type: string = '-1';
    date_inter: DateJson;
    temperature: string;
    meteo: string = '-1';
    commentaires: string;
    interRuches: InterRuche[] = [];

    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/models/intervention.ts